import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";
import AppContext from "./components/AppContext";

const rootElement = document.getElementById("root");

ReactDOM.createRoot(rootElement).render(
	<AppContext>
		<App />
	</AppContext>
);
